import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/item-classes', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/item-classes', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/item-classes', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/item-classes', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/admin/item-classes/detail', {
      params,
    })
    return response.data.data.document || null
  },
}